/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Bulb: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 0H11V3H13V0ZM2.80664 4.22168L4.22084 2.80748L6.34214 4.92878L4.92794 6.34298L2.80664 4.22168ZM0 11H3V13H0V11ZM17.6572 4.92871L19.7785 2.80741L21.1927 4.22161L19.0714 6.34291L17.6572 4.92871ZM24 11H21V13H24V11ZM5 12C5 8.141 8.14 5 12 5C15.86 5 19 8.141 19 12C19 14.715 17.419 17.171 15 18.319V23H9V18.319C6.581 17.17 5 14.714 5 12Z'
      fill='currentColor'
    />
  </React.Fragment>
)
